import Vue from 'vue'
import Router from 'vue-router'
import PagePlayables from '@/views/Playables.vue'
import PagePlayable from '@/views/Playable.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Playables',
      component: PagePlayables
    },
    {
      path: '/playable/:playable_id',
      name: 'Playable',
      component: PagePlayable
    }
  ]
})
